.messageBubble {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 12px 16px;
    max-width: 75%;
    word-wrap: break-word;
}

.messageLeft {
    align-self: flex-start;
    background-color: var(--hps-light-gray);
    border-radius: 12px 12px 12px 0;
}

.messageRight {
    background-color: var(--hps-dark-gray);
    border-radius: 12px 12px 0 12px;
}

.messageWrapperLeft {
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    align-items: flex-start;
}

.messageWrapperRight {
    display: flex;
    flex-direction: column;
    align-self: flex-end;
    align-items: flex-end;
}
